export function omit(obj, ...props) {
  const result = { ...obj }
  props.forEach(function (prop) {
    delete result[prop]
  })
  return result
}

/**
 * Index of the first entry in range of all entries that has start property strictly greater than given date.
 * Entries with not corresponding teamId are not taken into account.
 * @param {[Entry]} entries Range of Entries
 * @param {Date} date
 * @param {String} teamId
 * @return {null|number} Desired index or null if such index doesn't exists
 */
export function lowerBound(entries, date, teamId) {
  if (entries.length === 0) {
    return null
  }

  const begin = beginOfTeamSubarray(entries, teamId)
  const end = endOfTeamSubarray(entries, teamId)

  if (begin === null && end === null) {
    return null
  }

  for (let i = begin; i <= end; i++) {
    const entry = entries[i]
    if (entry.start > date) {
      return i
    }
  }

  return null
}

/**
 * Index of the last entry in range of all entries that has end property strictly less than given date.
 * Entries with not corresponding teamId are not taken into account.
 * @param {[Entry]} entries Range of Entries
 * @param {Date} date
 * @param {String} teamId
 * @return {null|number} Desired index or null if such index doesn't exists
 */
export function upperBound(entries, date, teamId) {
  if (entries.length === 0) {
    return null
  }

  const begin = beginOfTeamSubarray(entries, teamId)
  const end = endOfTeamSubarray(entries, teamId)

  if (begin === null && end === null) {
    return null
  }

  for (let i = end; i >= begin; i--) {
    const entry = entries[i]
    if (entry.end < date) {
      return i
    }
  }

  return null
}

/**
 * Index of the first entry in range of all entries with given teamId
 * @param {[Entry]} entries
 * @param {String} teamId
 * @return {null|number} Desired index or null if such index doesn't exists
 */
export function beginOfTeamSubarray(entries, teamId) {
  let index = 0
  while (index < entries.length) {
    if (entries[index].teamId === teamId) {
      return index
    }
    index++
  }

  return null
}

/**
 * Index of the last entry in range of all entries with given teamId
 * @param {[Entry]} entries
 * @param {String} teamId
 * @return {null|number} Desired index or null if such index doesn't exists
 */
export function endOfTeamSubarray(entries, teamId) {
  let index = entries.length - 1
  while (index >= 0) {
    if (entries[index].teamId === teamId) {
      return index
    }
    index--
  }

  return null
}

/**
 * Obtains an index of the entry from the entry id
 * @param {[Entry]} entries
 * @param {String} entryId
 * @return {number}
 * @throws {Error} If there is no corresponding entry
 */
export function getEntryIndex(entries, entryId) {
  for (let i = 0; i < entries.length; i++) {
    const entry = entries[i]
    if (entry.id === entryId) {
      return i
    }
  }

  throw new Error('ignored entry, passed to collision check, does not exist')
}

/**
 * A number of entries ascribed to the team
 * @param {[Entry]} entries
 * @param {String} team Team id
 * @return {number}
 */
export function getNumberOfTeamEntries(entries, team) {
  let counter = 0
  for (let i = 0; i < entries.length; i++) {
    const entry = entries[i]
    /* istanbul ignore else */
    if (entry.teamId === team) {
      counter++
    }
  }

  return counter
}

export function advanceIndex(entries, indexToAdvance, advanceValue) {
  const advancedIndex = indexToAdvance + advanceValue
  if (advancedIndex >= entries.length || advancedIndex < 0) {
    /* The next / previous entry does not exist, we have reached the boarder of array */
    return null
  }
  if (entries[advancedIndex].teamId !== entries[indexToAdvance].teamId) {
    /* The next / previous entry does not exist, we have reached the boarder of team subarray */
    return null
  }
  return advancedIndex
}

export function getTeams(entries) {
  const teams = []
  let prev = null

  for (let i = 0; i < entries.length; i++) {
    const current = entries[i].teamId
    if (current !== prev) {
      teams.push(current)
      prev = current
    }
  }

  return teams
}

export function getNextLocationColor(allColors, alreadyUsed) {
  let colorsToChooseFrom = allColors.filter((color) => !alreadyUsed.includes(color))
  if (colorsToChooseFrom) {
    return colorsToChooseFrom[0]
  } else {
    return allColors[Math.floor(Math.random() * allColors.length)]
  }
}

export function parseJWT(token) {
  var base64Url = token.split('.')[1],
    base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'),
    jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join(''),
    )

  return JSON.parse(jsonPayload)
}
